import request from '@/utils/request'

let ImportApi = {

    /* 上传商品导入文件  */
    get_upload(formData) {
        return request._upload('/shop/product.product/excel_upload', formData);
    },

    /* 获取后台域名 */
    uploadUrl(data) {
        return request._get('/shop/plus.customer.customer/upload_url', data);
    },
    // 获取域名
    getHost(data) {
        return request._get('/shop/product.product/getHost', data);
    },
}

export default ImportApi;



// WEBPACK FOOTER //
// ./src/api/import.js